import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import palette from "../../../config/colorPalette";
import { clone, isNil, isEmpty } from "ramda";
import { Button, TextField } from "@mui/material";
import { putAPIKey } from "../../api";
const APIKeys = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const currentConfig = useSelector((state) => state.configData.data);
  const [forms, setForms] = useState([]);

  useEffect(() => {
    const result = [];
    if (!isNil(currentConfig)) {
      for (let indexService = 0; indexService < currentConfig.externalServices.length; indexService++) {
        for (
          let indexService2 = 0;
          indexService2 < currentConfig.externalServices[indexService].services.length;
          indexService2++
        ) {
          for (
            let indexConfigForm = 0;
            indexConfigForm < currentConfig.externalServices[indexService].services[indexService2].configForm.length;
            indexConfigForm++
          ) {
            if (
              currentConfig.externalServices[indexService].services[indexService2].configForm[indexConfigForm].name ===
              "api_key"
            ) {
              const field = {
                name: currentConfig.externalServices[indexService].services[indexService2].name,
                ref: currentConfig.externalServices[indexService].services[indexService2].ref,
                desc: currentConfig.externalServices[indexService].services[indexService2].desc,
                value:
                  currentConfig.externalServices[indexService].services[indexService2].configForm[indexConfigForm]
                    .value,
                indexService: indexService,
                indexService2: indexService2,
                indexConfigForm: indexConfigForm,
              };
              result.push(field);
            }
          }
        }
      }
    }
    setForms(result);
  }, [currentConfig]);

  return (
    <div style={{ margin: "1%" }}>
      <h1>{intl.formatMessage({ id: "api_keys" })}</h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "10px",
          marginTop: "1.5%",
        }}
      >
        {!isEmpty(forms) &&
          forms.map((form, formIndex) => {
            return (
              <div
                key={`${form.name}_${formIndex}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <TextField
                  id={`form${formIndex}`}
                  margin="dense"
                  style={{ width: "25rem" }}
                  variant="outlined"
                  value={form.value}
                  label={form.name.toUpperCase()}
                  onChange={(event) => {
                    const value = event.target.value;
                    let newForms = clone(forms);
                    newForms[formIndex].value = value;
                    setForms(newForms);
                  }}
                />
                <Button
                  id={`button${formIndex}`}
                  variant="contained"
                  style={{
                    padding: "0.2rem 0.5rem",
                    backgroundColor: palette.primary,
                    color: "white",
                  }}
                  onClick={async () => {
                    const a = await putAPIKey(form.ref, form.value, intl);
                    console.log(a);
                  }}
                >
                  {intl.formatMessage({ id: "update" })}
                </Button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default APIKeys;
